// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3i7tG","buttons":"styles_buttons__3JoxO"};